import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxsModule } from '@ngxs/store';
import { LogTicketsState } from './log-tickets.state';

@NgModule({
  imports: [CommonModule, NgxsModule.forFeature([LogTicketsState])],
  declarations: []
})
export class LogTicketsModule {}
